import { useEffect, useState } from 'react';
import PrimaryButton from '../../shared/button/PrimaryButton';
import { NavigateFunction, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, DialogActions } from '@mui/material';
import { Subheading } from '../../shared/typography/PrimaryTypography';
import { GCP_PROJECT } from '../../../env';
import InvalidURL from '../../../views/shared/InvalidURL';
import GhostButton from '../../shared/button/GhostButton';
import lock_img from '../../../assets/lock-without-background.webp';
import { auth } from '../../../lib/google/firebase';

/**
 * Handles the staging area for Firebase Auth Actions to prevent auto trigger by email clients
 * @returns {JSX.Element}
 */
export const AuthActionRedirector = (): JSX.Element => {
  const [queryParams] = useSearchParams();
  const [subHeadingText, setSubHeadingText] = useState<string>();
  const [buttonText, setbuttonText] = useState<string>();
  const mode: string | null = queryParams.get('mode');
  const oob_code: string | null = queryParams.get('oobCode');
  const api_key: string | null = queryParams.get('apiKey');
  const navigate: NavigateFunction = useNavigate();

  // Handles redirection to firebase auth handler, required to prevent auto removal of MFA.
  const handleConfirmRedirect = (): void => {
    const url = `https://${GCP_PROJECT}.firebaseapp.com/__/auth/action?mode=${mode}&oobCode=${oob_code}&apiKey=${api_key}&lang=en`;
    window.open(url, '_blank');
    if (auth.currentUser) {
      auth.signOut();
    }
    navigate('/');
  };

  // Handles the conditional heading and button text generation based on Auth Action
  const generateInteractionText = (): void => {
    if (mode === 'revertSecondFactorAddition') {
      setSubHeadingText(
        'Are you sure that you want to remove the recently added Two-Factor Authentication from your account?'
      );
      setbuttonText('Remove');
    } else if (mode === 'resetPassword') {
      setSubHeadingText('Are you sure that you want to reset your password?');
      setbuttonText('Reset');
    } else {
      navigate('/*');
    }
  };

  // Triggers generation of conditional text on first render.
  useEffect(() => {
    generateInteractionText();
  }, []);

  return mode && oob_code && api_key ? (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          minHeight: '70vh'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20%' }}>
          <img src={lock_img} width={250} />
        </Box>
        <Subheading weight="Medium" sx={{ my: 4, maxWidth: '50%' }}>
          {subHeadingText}
        </Subheading>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <PrimaryButton sx={{ minWidth: 150 }} onClick={handleConfirmRedirect}>
            {buttonText}
          </PrimaryButton>
          <GhostButton
            sx={{ minWidth: 150 }}
            onClick={() => {
              navigate('/');
            }}
            outlined
            dark
          >
            Cancel
          </GhostButton>
        </DialogActions>
      </Box>
    </>
  ) : (
    <InvalidURL />
  );
};
